import { usePractitionerRoleContext } from '../contexts/PractitionerRoleContext';
import { useSessionContext } from '../contexts/SessionContext';
import { oids } from '../configs/Settings';

/**
 * Hook para obter o practitioner ID do usuário logado
 */
export function usePractitionerId() {
    const { userPractitioner } = usePractitionerRoleContext();
    const { user } = useSessionContext();

    if (userPractitioner?.id) {
        return userPractitioner.id;
    }

    if (user?.username) {
        return `${oids.cpf}-${user.username}`;
    }

    return null;
}

/**
 * Função para construir practitioner ID usando CPF
 */
export function buildPractitionerId(cpf: string): string {
    return `${oids.cpf}-${cpf}`;
}

/**
 * Função para extrair CPF do practitioner ID
 */
export function extractCpfFromPractitionerId(practitionerId: string): string | null {
    const parts = practitionerId.split('-');
    if (parts.length >= 2) {
        return parts[parts.length - 1];
    }
    return null;
}

/**
 * Função para validar se um practitioner ID está no formato correto
 */
export function isValidPractitionerId(practitionerId: string): boolean {
    return practitionerId.includes(`${oids.cpf}-`);
}
